import { Dispatch } from "react"
import { generalOpenModalError, generalOpenModalInfo, generalShowLoader } from "../general.actions"
import * as http from '../../api/http'
import { ENDPOINTS } from "../../api/config"
import { KEYS } from "../../constants/keysStorage"
import { BITACORA_TYPES } from "../../constants/bitacora.types"

export const setDataBitacora = (data: any) => ({ type: BITACORA_TYPES.BITACORA_SET_HISTORIAL_RESULT, payload: data });
export const setResetModuleBitacora = () => ({ type: BITACORA_TYPES.BITACORA_CLEAR_MODULE, payload: null });

export const getHistorialBitacora = (form: any) => async (dispatch: Dispatch<any>) => {
  dispatch(generalShowLoader(true))

  const formConsulta = {
    ...form,
    Dte: form.Dte || "-1",
    DocCliente: form.DocCliente || "-1",
    Destinatario: form.Destinatario || "-1",
    tokenGateway: localStorage.getItem(KEYS.TOKEN) ?? '',
  }
  console.log(formConsulta);

  let message = 'No se encontraron registros con los filtros aplicados.'
  return await http
    .post(ENDPOINTS.BITACORA_CORREOS_HISTORIAL, formConsulta)
    .then(async (res: any) => {
      if (res.body?.length > 0) {
        dispatch(setDataBitacora(res.body));
      } else {
        dispatch(generalOpenModalInfo(message));
        dispatch(setDataBitacora([]));
      }
    })
    .catch(async (err: any) => {
      dispatch(generalOpenModalError(err?.response?.data?.message ?? message, err?.response?.data?.status))
      return err?.response?.data?.message ?? message
    })
    .finally(() => dispatch(generalShowLoader(false)))
}